// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qk_a bhl_su bhl_kv bhl_kw","PostDetailRight__brandDaysPosts":"qk_b bhl_su bhl_kv bhl_kw"};